var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TaskStatus',_vm._b({staticClass:"table-data-status",attrs:{"readonly":""}},'TaskStatus',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }